import { getContract } from 'hook';
import TokenJSON from 'contracts/abiToken.json';
import { convertEToNumber, formatUnits } from 'utils/helpers';
import { METAMASK } from 'components/Header';
import { APP_NETWORKS_SUPPORT } from 'common/constant';

/**
 * get Balance
 * @returns balance
 */
export const getBalance = async (
  library: any,
  address: string,
  tokenAddress: string
) => {
  const tokenInst = getContract(tokenAddress, TokenJSON.output.abi, library);
  if (address) {
    const balance = await tokenInst.balanceOf(address);
    const decimals = await tokenInst.decimals();

    return {
      balance: convertEToNumber(formatUnits(balance, 'wei'), decimals)
    };
  } else {
    return {
      balance: 0
    };
  }
};

declare let window: any;

export const setupNetwork = async (library: any, chainId?: number) => {
  if (library?.provider) {
    try {
      const networkInfo = APP_NETWORKS_SUPPORT[Number(chainId)];
      if (networkInfo) {
        try {
          await library?.provider.request({
            method: 'wallet_switchEthereumChain',
            params: [{ chainId: networkInfo.details?.chainId }]
          });
          return true;
        } catch (error: any) {
          //Reject metamask
          if (error.code === 4001) {
            return;
          }

          // This error code indicates that the chain has not been added to MetaMask.
          if (error.code === 4902) {
            try {
              await library?.provider.request({
                method: 'wallet_addEthereumChain',
                params: [
                  {
                    ...(networkInfo.details || {})
                  }
                ]
              });
              return true;
            } catch (addError) {
              return false;
            }
          } else {
            return false;
          }
        }
      } else return false;
    } catch (e) {
      return false;
    }
  } else {
    return false;
  }
};

export const addToken = async (
  library: any,
  data: {
    tokenType: string;
    tokenAddress: string;
    tokenSymbol: string;
    tokenDecimals: number;
    tokenImage?: string;
  }
) => {
  try {
    const {
      tokenType,
      tokenAddress,
      tokenSymbol,
      tokenDecimals,
      tokenImage = ''
    } = data || {};

    if (tokenAddress && library?.provider) {
      await library?.provider.request({
        method: 'wallet_watchAsset',
        params: {
          type: tokenType,
          options: {
            address: tokenAddress, // The address that the token is at.
            symbol: tokenSymbol, // A ticker symbol or shorthand, up to 5 chars.
            decimals: tokenDecimals, // The number of decimals in the token
            image: tokenImage // A string url of the token logo
          }
        }
      });
    }
  } catch (error) {
    console.log(error);
  }
};
